/**
 * VendorFlagTypeService
 * Service for managing vendor flag types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor flag type CRUD operations
 */
export class VendorFlagTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorFlagTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorFlagTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorFlagTypeService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorFlagTypeService.BASE_PATH = 'api/vendor-flag-types';
//# sourceMappingURL=VendorFlagTypeService.js.map